export default "__VITE_ASSET__252d91c7__"